export const filtersComponents = {
  SocioQuestionnaireTableFilters: () => import("./SocioQuestionnaireTableFilters.vue"),
};
